import { Icon, PageTitle } from '@fasstech/middle-design-system';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { includes } from 'ramda';

const ManualSignatureCompleted = ({ getMiddleText, activeUserRoles }) => {
  const isProspect = includes('PROSPECT', activeUserRoles);
  return (
    <PageLayout>
      <Icon name={'circleSign'} size={70}/>
      <PageTitle
        className={'text-center'}>{getMiddleText(
          isProspect
            ? 'PROCESSDEVENTE_SIGNATURE_MANUELLE_STARTED_PROSPECT_TITLE'
            : 'PROCESSDEVENTE_SIGNATURE_MANUELLE_STARTED_TITLE'
        )}</PageTitle>
      <div className={'mt-8'}>
        <p>{getMiddleText(
          isProspect
            ? 'PROCESSDEVENTE_SIGNATURE_MANUELLE_STARTED_PROSPECT_TEXT'
            : 'PROCESSDEVENTE_SIGNATURE_MANUELLE_STARTED_TEXT'
        )}</p>
      </div>
    </PageLayout>
  );
};

export default ManualSignatureCompleted;
